module.exports = __webpack_public_path__ + "static/PlayfairDisplayItalic-8bd038cd447b1bef826ebf73e1ebbdb2.ttf";